import './App.css';
import MemoryCard from './components/memory-card/MemoryCards';


function App() {
  return (
    <div className="App">
      <MemoryCard />

    </div>
  );
}

export default App;
